import * as React from 'react';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'ha/helpers/config';
import { IntlProvider } from 'ha/i18n';
import { SheetsRegistry } from 'react-jss/lib/jss';
import {
  createGenerateClassName,
  MuiThemeProvider,
} from '@material-ui/core/styles';
import JssProvider from 'react-jss/lib/JssProvider';

import theme from '../theme';
import { Store } from 'redux';
import { Config } from 'ha/config';
import { IntlObject } from 'ha/i18n/types';

interface Props {
  store: Store;
  config: Config;
  intl: IntlObject;
  sheetsRegistry: SheetsRegistry;
}

const AppContextProvider: React.SFC<Props> = ({
  store,
  config,
  intl,
  children,
  sheetsRegistry,
}) => {
  const generateClassName = createGenerateClassName({
    dangerouslyUseGlobalCSS: false,
    productionPrefix: 'c',
  });

  return (
    <JssProvider
      registry={sheetsRegistry}
      generateClassName={generateClassName}
    >
      <MuiThemeProvider theme={theme} sheetsManager={new Map()}>
        <Provider store={store}>
          <ConfigProvider value={config}>
            <IntlProvider value={intl}>{children}</IntlProvider>
          </ConfigProvider>
        </Provider>
      </MuiThemeProvider>
    </JssProvider>
  );
};

export default AppContextProvider;
